import React from 'react';
import LabelInput from './LabelImput';

interface PasswordInputProp {
  onBlur?: (event: any) => void;
  showLost: boolean;
}

export default class PasswordInput extends React.Component<PasswordInputProp> {
  render(): React.ReactNode {
    return (
      <LabelInput
        id="login-password"
        labelText={this.props.showLost ? 'Passwort' : 'Neues Passwort'}
        type="password"
        name="password"
        inputDynparam={{ size: 36, maxLength: 255 }}
        onBlur={(ev) => {
          if (this.props.onBlur != undefined) this.props.onBlur(ev);
        }}
      >
        {this.props.showLost ? (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(even) => {
              window.historyHelper.memory.push('/login?action=lost', null);
            }}
          >
            <span style={{fontWeight:'bold', color:'#c20f0d'}}>(vergessen?)</span>
          </a>
        ) : null}
      </LabelInput>
    );
  }
}
